/* TODO: t() */
import React, { useRef } from 'react';
import { StyleSheet, View } from 'react-native';

import formatDate from '../../../../core/support/formatDate';
import { themeColors } from '../../../uiold/Constants';

import { Checkbox, CollapsibleView } from '../../../uiold';

import { Market } from '../../../../types/shared/Market';
import { VendorAddonStatus } from '../../../../types/shared/Vendor';

type Props = {
  market: Market;
  status: VendorAddonStatus;
  availableDates: Array<string>;
  selectedDates: Array<string>;
  onChange: (selectedDates: Array<string>) => void;
  isVendor?: boolean;
};

export function AddonMarketDateSelector(props: Props) {
  let {
    market,
    status,
    availableDates,
    selectedDates,
    onChange,
    isVendor,
  } = props;

  let selectedDatesSet = new Set(selectedDates);

  let noDatesSelected = selectedDates.length === 0;
  let allDatesSelected =
    availableDates.length > 0 && availableDates.length === selectedDates.length;
  let initiallyCollapsed =
    noDatesSelected || allDatesSelected || status !== 'Partial';

  let count = selectedDates.length;
  let title = `${market.name} (${count} ${count === 1 ? 'date' : 'dates'})`;

  let ref = useRef<CollapsibleView>(null);

  let onToggleDate = (date: string) => {
    if (status !== 'Partial') {
      return;
    }
    let shouldSelect = !selectedDatesSet.has(date);
    let newSelectedDates = selectedDates.filter((d) => d !== date);
    if (shouldSelect) {
      newSelectedDates.push(date);
    }
    onChange(newSelectedDates);
  };

  let onChangeAll = () => {
    if (status !== 'Partial') {
      return;
    }
    let shouldSelectAll = !allDatesSelected;
    let newSelectedDates = shouldSelectAll ? availableDates.slice() : [];
    onChange(newSelectedDates);
  };

  const currentDate = new Date(new Date().setHours(0, 0, 0, 0));

  return (
    <View style={styles.rowFlex} key={market.id}>
      {isVendor ? null : (
        <View style={styles.outsideCheckbox}>
          <Checkbox
            style={styles.paddingRight}
            isChecked={allDatesSelected}
            onChange={() => {
              // eslint-disable-next-line no-underscore-dangle
              ref.current?._toCollapsed();
              onChangeAll();
            }}
          />
        </View>
      )}
      <CollapsibleView
        ref={ref}
        key={market.id}
        isDisabled={availableDates.length === 0}
        noLeftCheckbox={true}
        title={title}
        titleStyle={styles.marketText}
        style={[
          status === 'Partial' ? styles.box : styles.boxDisabled,
          styles.defaultWidth,
        ]}
        contentStyle={styles.collapsibleContent}
        subtitle={market.description}
        initialCollapseState={initiallyCollapsed}
      >
        <View style={styles.marketDates}>
          {availableDates.map((date) => (
            <View style={styles.marketDate} key={market.id + ':' + date}>
              <Checkbox
                isDisabled={new Date(date) < currentDate && isVendor === true}
                isChecked={selectedDatesSet.has(date)}
                onChange={() => onToggleDate(date)}
                text={formatDate(date, {
                  fromUTC: true,
                  includeDayOfWeek: true,
                })}
              />
            </View>
          ))}
        </View>
      </CollapsibleView>
    </View>
  );
}

let styles = StyleSheet.create({
  marketText: {
    color: '#444',
    fontWeight: '600',
  },
  collapsibleContent: {
    paddingTop: 0,
  },
  marketDates: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  marketDate: {
    marginVertical: 7,
    paddingHorizontal: 12,
    minWidth: '20%',
  },
  box: {
    marginTop: 10,
    borderRadius: 3,
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#f4f4f4',
  },
  boxDisabled: {
    marginTop: 10,
    borderRadius: 3,
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: themeColors.white,
    width: '95%',
  },
  defaultWidth: { width: '95%' },
  outsideCheckbox: {
    marginTop: 10,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowFlex: { flexDirection: 'row' },
  paddingRight: { paddingRight: 2 },
});
